var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrikeoutEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_148_1",
    "data-name": "Component 148 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 24,
    height: 24,
    rx: 2,
    fill: "#e6e6e8",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362",
    transform: "translate(-592 -368)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(598 387)",
    fill: "#0d0d0d",
    fontSize: 16,
    fontFamily: "Verdana"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 12,
    height: 1,
    transform: "translate(598 381)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeoutEditorIcon);
export default __webpack_public_path__ + "static/media/strikeout-editor-icon.66e89ea27c70e512bcbff9163472cb5b.svg";
export { ForwardRef as ReactComponent };